// お気に入り関連
var fillFavoritedCount = function() {
  var customer_id = $("#customer-id").html();
  if(customer_id) {
    var url = "/a/wishlist?type=api&customerid=" + customer_id + "&version=1";
    $.ajax({
      type: 'GET',
      url: url,
      success: function(data){
        $(".js-favorite-count").html(data["count"]).removeClass("hide-count");
      },
      error: function(e) {
        $(".js-favorite-count").html(0).removeClass("hide-count");
      }
    })
 }
}

var switchFavoriteButton = function(product_id, variant_id){
  var customer_id = $("#customer-id").html();
  var url = "/a/wishlist?type=api&customerid=" + customer_id + "&version=1";
  $.ajax({
    type: 'GET',
    url: url,
    success: function(data){
      var items = data["items"];
      var favorited = false;
      $.each(items, function(index, item){
        if(item["id"] == product_id && item["variant_id"] == variant_id) {
          favorited = true;
        }
      })
      if(favorited) {
      $(".js-favorite-button-" + variant_id).addClass("favorited");
      $(".js-favorite-button-text-" + variant_id).html("お気に入りに追加済み");
      }
    },
    error: function(e) {
    }
  })

}

var onClickFavoriteButton = function(product_id, variant_id) {
  var link = location.href;
  var customer_id = $("#customer-id").html();
  if(!customer_id) {
    if(link) {
      location.href = "/account/login?checkout_url=" + link;
    } else {
      location.href = "/account/login";
    }
  }
    
  if($(".js-favorite-button-" + variant_id).hasClass("favorited")) {
    removeFavorite(product_id, variant_id);
  } else {
    addFavorite(product_id, variant_id);
  }
}

var addFavorite = function(product_id, variant_id){
  $(".js-favorite-button-" + variant_id).attr("disabled", true);
  var count = Number($(".js-favorite-count").html());
  var customer_id = $("#customer-id").html();
  var post_url = "/a/wishlist?type=api";
  var api_key = $("#favorite-api-key").html(); 
  $(".js-favorite-count").html(count + 1);
  $(".js-favorite-button-" + variant_id).addClass("favorited");
  $(".js-favorite-card-" + variant_id).addClass("favorited");
  $(".js-favorite-button-text-" + variant_id).html("お気に入りに追加済み");
  var data = {
    productid: product_id,
    variantid: variant_id,
    customerid: customer_id,
    action: 'add',
    apikey: api_key,
    version: 1
  };
  $.ajax({
    type: 'POST',
    url: post_url,
    data: data,
    success: function(data){
      $(".js-favorite-button-" + variant_id).attr("disabled", false);
    },
    error: function(e) {
      var count = Number($(".js-favorite-count").html());
      $(".js-favorite-count").html(count - 1);
      $(".js-favorite-button-" + variant_id).removeClass("favorited");
      $(".js-favorite-card-" + variant_id).removeClass("favorited");
      $(".js-favorite-button-text-" + variant_id).html("お気に入りに追加");
      $(".js-favorite-button-" + variant_id).attr("disabled", false);
      console.log(e);
    }
  });
}

var removeFavorite = function(product_id, variant_id){
  $(".js-favorite-button-" + variant_id).attr("disabled", true);
  var count = Number($(".js-favorite-count").html());
  var customer_id = $("#customer-id").html();
  var post_url = "/a/wishlist?type=api";
  var api_key = $("#favorite-api-key").html(); 
  $(".js-favorite-count").html(count - 1);
  $(".js-favorite-button-" + variant_id).removeClass("favorited");
  $(".js-favorite-card-" + variant_id).removeClass("favorited");
  $(".js-favorite-button-text-" + variant_id).html("お気に入りに追加");
  var data = {
    productid: product_id,
    variantid: variant_id,
    customerid: customer_id,
    action: 'remove',
    apikey: api_key,
    version: 1
  };
  $.ajax({
    type: 'POST',
    url: post_url,
    data: data,
    success: function(data){
      $(".js-favorite-button-" + variant_id).attr("disabled", false);
    },
    error: function(e) {
      var count = Number($(".js-favorite-count").html());
      $(".js-favorite-count").html(count + 1);
      $(".js-favorite-button-" + variant_id).addClass("favorited");
      $(".js-favorite-card-" + variant_id).addClass("favorited");
      $(".js-favorite-button-text-" + variant_id).html("お気に入りに追加済み");
      $(".js-favorite-button-" + variant_id).attr("disabled", false);
      console.log(e);
    }
  });
}

$(function(){
  var prepareFavorite = setInterval(function(){
    try {
      var list_id = SWGetCustomerWishlistId();
      clearInterval(prepareFavorite);
      fillFavoritedCount();
      var product_id = $("#product-id").html();
      var variant_id = $("#variant-id").html();
      if(product_id && variant_id) {
        switchFavoriteButton(product_id, variant_id);
      }
    } catch {
    }
  }, 100)
})